const Company = {
    name: 'BrightStarr Consulting',
    email: 'subs@brightstarr.ai',
}

export default Company